import { render, staticRenderFns } from "./SalesOrderDetails.vue?vue&type=template&id=1e75455a&scoped=true&"
import script from "./SalesOrderDetails.vue?vue&type=script&lang=js&"
export * from "./SalesOrderDetails.vue?vue&type=script&lang=js&"
import style0 from "./SalesOrderDetails.vue?vue&type=style&index=0&id=1e75455a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e75455a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VContainer,VDataTable})
